import { convertEnumFilterToApi } from 'v5/platform/filters/filterConverters';
import { Nullable } from 'v5/platform/typescript';

export function mergeTeamScopingIntoHttpFilters(query: {
  teamId: Nullable<number>;
}): Record<string, unknown> {
  if (query.teamId === null) {
    return {};
  }

  return {
    enterprise_team_id: convertEnumFilterToApi({
      operator: 'matchAny',
      value: [query.teamId]
    })
  };
}
